import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { AssignModalTableColumn } from "./AssignModalTableColumn";

const AssignModalTable = ({
  productsList,
  handleProductSelection,
  notAssignedAmount,
  selectedProducts,
  productType,
  handleAssignAmount,
  rowData,
}: any) => {
  const { t } = useTranslation();

  return (
    <div>
      <Table
        columns={
          AssignModalTableColumn(
            t,
            handleProductSelection,
            notAssignedAmount,
            selectedProducts,
            productType,
            handleAssignAmount,
            rowData,
          ) as any
        }
        rows={productsList}
      />
    </div>
  );
};

export default AssignModalTable;
